import React from 'react'
import { Typography } from '@mui/material'
import Grid2 from '@mui/material/Unstable_Grid2' // Grid version 2
import * as Money from '../utilities/money'
import GridBomSelect from './GridBomSelect.js'
import { Colors } from '../styles/theme'
import CorrectCopyright from './CorrectCopyright.js'

function calcLineItemTotal(productRow) {
    return Money.getLineItemTotal(
        productRow['itemQty'],
        productRow['sugRetail']
    )
}
const sxLinkLike = {
    fontWeight: '500',
    color: `${Colors.companyColors.eb_text}`,
    textDecoration: 'underline',
    '&:hover': {
        cursor: 'pointer',

        fontSize: '103%' /* Increase font size on hover */,
        // backgroundColor: `${Colors.secondary}`,

        color: `${Colors.companyColors.eb_bolt}`,
        // textShadow: ' 0.15px 0.15px 0.15px #000',
        fontWeight: '500',
    },
}
// const gridLineItemSx = {
//     borderBottom: 0.25,
//     borderColor: '#f6c995',
//     '& .MuiGrid2-root ': {
//         pt: 0.3,
//     },
//     // '& .':{},
// }
const leftLineItemSx = {
    pl: 1,
    // display: 'flex',
    justifyContent: 'flex-start',
    // alignItems: 'center',
    // fontSize: '0.8rem',
    // textAlign: 'left',
}
const rightLineItemSx = {
    textAlign: 'right',
    // display: 'flex',
    // justifyContent: 'flex-end',
    // alignItems: 'center',
    pr: 1,
    // fontSize: '0.8rem',
}

const itemTitles = {
    productID: 'Item Code',
    descriptionTitle: 'Descrip.',
    pkgQty: 'Package Qty',
    sugRetail: 'Price',
    itemQty: 'Quantity',
    lineItemTotal: 'SubTotal',
}
function getRightLineItemsSx(productProp) {
    const sxGridBomSelect = productProp === 'itemQty' ? { pt: 1, pb: 0.3 } : {}
    return { ...rightLineItemSx, ...sxGridBomSelect }
}
function getRightSideComponent(
    productRow,
    productProp,
    handleInputChange,
    handleValue,
    showDialog
) {
    if (productProp === 'descriptionTitle') {
        return (
            <Typography sx={{ ...sxLinkLike }} onClick={showDialog}>
                <CorrectCopyright
                    copyrightTextValue={productRow[productProp]}
                />
            </Typography>
        )
        // return <Link href={productRow.href}>{productRow[productProp]}</Link>
    }
    if (productProp === 'itemQty') {
        return (
            <GridBomSelect
                productRow={productRow}
                handleInputChange={handleInputChange}
                handleValue={handleValue}
            />
        )
    }
    if (productProp === 'lineItemTotal') {
        return <Typography>{calcLineItemTotal(productRow)}</Typography>
    }
    return <Typography>{productRow[productProp]}</Typography>
}
export default function MobileLineItem({
    productRow,
    productProp,
    handleInputChange,
    handleValue,
    showDialog,
}) {
    // console.log(`In MobileLineItem`)

    const rightSideComponent = getRightSideComponent(
        productRow,
        productProp,
        handleInputChange,
        handleValue,
        showDialog
    )
    const rightLineItemSxFn = getRightLineItemsSx(productProp)

    return (
        <>
            <Grid2 xs={5} sx={leftLineItemSx}>
                <Typography> {itemTitles[productProp]}</Typography>
            </Grid2>
            <Grid2 xs={15} sx={rightLineItemSxFn}>
                {rightSideComponent}
            </Grid2>
        </>
    )
}
